import LearnPageLayout from "@/components/LearnPageLayout";
import { pageAntidepressantsDontWork } from "./learnDataAntidepressantsDontWork";

const AntidepressantsDontWorkPage = () => (
  <LearnPageLayout
    title={pageAntidepressantsDontWork.title}
    description={pageAntidepressantsDontWork.description}
    canonical={pageAntidepressantsDontWork.canonical}
    h1={pageAntidepressantsDontWork.h1}
    breadcrumbLabel={pageAntidepressantsDontWork.breadcrumbLabel}
    crumbs={pageAntidepressantsDontWork.crumbs}
    shortAnswer={pageAntidepressantsDontWork.shortAnswer}
    keyTakeaways={pageAntidepressantsDontWork.keyTakeaways}
    sections={pageAntidepressantsDontWork.sections}
    faqs={pageAntidepressantsDontWork.faqs}
    sources={pageAntidepressantsDontWork.sources}
    schemaJson={pageAntidepressantsDontWork.schemaJson}
    relatedLinks={pageAntidepressantsDontWork.relatedLinks}
    reviewBlock={pageAntidepressantsDontWork.reviewBlock}
  />
);

export default AntidepressantsDontWorkPage;
